import type { QueryFunctionContext, QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { getBasket, getBasketBasic } from './basket.api';
import type { OptionalQueryOptions, QueryApiOptions } from '../../types/types';
import { BasketGetBasicResponse, BasketGetResponse } from '@as-react/common-types';

export const basketQueryKeys = {
  all: () => ['basket'] as QueryKey,
  getBasket: () => [...basketQueryKeys.all(), 'basket'] as QueryKey,
  getBasketBasic: () => [...basketQueryKeys.all(), 'basketBasic'] as QueryKey,
};

export const basketQueries = (apiOptions: QueryApiOptions) => ({
  getBasket: <TReturnData = BasketGetBasicResponse>(
    options: OptionalQueryOptions<BasketGetResponse, TReturnData> = {}
  ): UseQueryOptions<BasketGetResponse, Error, TReturnData> => ({
    ...options,
    queryKey: basketQueryKeys.getBasket(),
    queryFn: (context: QueryFunctionContext) => getBasket(apiOptions, context),
  }),
  getBasketBasic: <TReturnData = BasketGetBasicResponse>(
    options: OptionalQueryOptions<BasketGetBasicResponse, TReturnData> = {}
  ): UseQueryOptions<BasketGetBasicResponse, Error, TReturnData> => ({
    ...options,
    queryKey: basketQueryKeys.getBasketBasic(),
    queryFn: (context: QueryFunctionContext) => getBasketBasic(apiOptions, context),
  }),
});
